webpackJsonp([35783957827783],{

/***/ 26:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIuNjQgMTY5LjUyIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmVmZWZlO2ZpbGwtcnVsZTpldmVub2RkO308L3N0eWxlPjwvZGVmcz48dGl0bGU+bGl2ZXI8L3RpdGxlPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTI1Ljg1LDc1LjY4QTE0NC44LDE0NC44LDAsMCwwLDEzMS4yOCw5OWMuMjYsMS41NS43OCwzLjExLDMuMSwyLjA3LDE3LjM0LTcuMjQsMjguMjEtMTguNjIsMzAuODEtMzgsMy44OC0zMS4zMSwyNC41OC0zMi44NiwyNy4xNy00OC42NC41Mi0yLjU5LjUyLTUuMTgtMS44MS03LTIxLjIyLTE1Ljc5LTQ3LjM2LTIuODUtNjguMDcsNy43Ny0xLjU1LDEtMS41NSwyLjA3LTEuMjksMy42MiwzLjYzLDE4LjYzLDEsMzcuNTIsNC42Niw1Ni45M1pNMTAzLjU5LDY1LjA3QTg4LjI1LDg4LjI1LDAsMCwxLDg5LjEsMzIuNDZjLS4yNi0xLjgxLS4yNi00LjQtMS4yOS01LjY5LTEuNTYtMS41NS00LjE1LDAtNi4yMSwwQzQzLjU0LDIzLjkyLDEuODgsNTMuOTQuMDcsOTQuODNjLS43OCwxNy42LDUuMTcsNDcuMzYsMTMuNzEsNjMuMTQsMi4wNywzLjg5LDQuNjYsNy41MSw4LjI4LDkuODNzNS4xNywyLjM0LDguNTQtLjI2YTI5LjM1LDI5LjM1LDAsMCwwLDYuMjEtNi40NkM0OC43MiwxNDQsNzUuODksMTQyLjcsOTQsMTMxLjMyYzguOC01LjQ0LDE2LjgyLTExLjkxLDIzLjMtMjEuMjMsMy4zNi00LjkxLDQuOTItMy4zNiwzLjM2LTkuMzItMy4xLTExLjktMTAuMDktMjUuNjEtMTcuMDktMzUuN1ptNC4xNS0xYzcuNzYsMTEuNjQsMTMuNzEsMjQuMzIsMTUuMjcsMzguNTYuNTIsNC4xNCwyLjMzLDYuNDYsNC45Miw4Ljc5LDIuMzMsMS44MiwxMS4zOSw4LjI4LDEzLjIsMy4xMWEyLjA3LDIuMDcsMCwwLDAtMS41NS0yLjg0Yy01LjE4LTEuODItOC01LjE4LTEwLjA5LTEwLjYyYTE0MS42MSwxNDEuNjEsMCwwLDEtMTAuMDktNTAuNzJjMC03LS4yNi0xNC4yMy41Mi0yMS43NCwwLTEuMjktLjI2LTMuMS0uMjYtNC42Ni0uNTItOCwxLjI5LTcuNS02Ljc0LTMuODgtLjc3LjI2LTEuMjkuNzctMi4wNy41Mi0uNzctLjc4LDAtMS41NSwwLTIuMzMsMS0yLjU5LDEuODEtNS40NCwyLjU5LTgsLjI2LS43OC43Ny0xLjgxLS4yNi0yLjMzLTIuNTgtMS41NS04LC4yNi05LjA2LDMuMS0xLjI5LDMuNjItMy4zNiw3LTUuMTcsMTAuNjFhNi42LDYuNiwwLDAsMS01LjcsMy44OGMtMy4zNi41Mi0zLjM2LDEtMi4zMyw0LjE0QTEzNi43MSwxMzYuNzEsMCwwLDAsMTA3LjczLDY0WiIvPjwvc3ZnPg=="

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _liver = __webpack_require__(26);
	
	var _liver2 = _interopRequireDefault(_liver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	
	  var siteInfo = data.site.siteMetadata;
	  var content = data.allMarkdownRemark.edges[0].node;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'content-container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Manifesto'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'manifesto' },
	        siteInfo.manifesto.map(function (item, key) {
	          return _react2.default.createElement(
	            'li',
	            { key: key },
	            item
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section-fw' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header' },
	          _react2.default.createElement('img', { src: _liver2.default, alt: '' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            content.frontmatter.title
	          )
	        ),
	        _react2.default.createElement('div', {
	          className: 'card-body',
	          dangerouslySetInnerHTML: { __html: content.html }
	        })
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-3d849eec5a11f56162f7.js